<template>
  <appear>
    <div v-intersection id="listings-cross-sell" class="listings-cross-sell mb-4 w-100">
      <div v-limit="700">
        <h2 class="header-md">
          {{ crossSellHeader }}
        </h2>
        <p class="font-base line-height-22">
          {{ crossSellCopy }}
        </p>
      </div>
      <div class="listings-cross-sell__cards listings__cards mt-4" @click="onCrossSellClick()">
        <div
          v-for="crossProperty in crossSellListings"
          :key="crossProperty.slug"
          class="listings__card mb-0"
        >
          <property-card
            :hide-roommates="true"
            :hide-actions="true"
            :clickable="false"
            :property="crossProperty"
          />
        </div>
        <!-- Avoids hanging cards -->
        <div class="listings__card" />
        <div :class="['listings-cross-sell__cta', isRoomsOffering ? 'homes' : 'rooms']">
          <inline-svg :src="require('@/assets/icons/arrow-right.svg')" />
        </div>
      </div>
    </div>
  </appear>
</template>

<script>
export default {
  name: 'ListingsCrossSell',
  props: {
    market: {
      type: Object,
      required: true,
    },
    isRoomsOffering: {
      type: Boolean,
      required: true,
    },
    crossSellListings: {
      type: Array,
      required: true,
    },
    onCrossSellClick: {
      type: Function,
      default: () => {},
      required: true,
    },
  },
  computed: {
    marketName() {
      return this?.market?.displayName
    },
    crossSellHeader() {
      return this.isRoomsOffering
        ? `Entire Homes and Apartments for Rent in ${this.marketName}.`
        : `Shared Homes and Apartments for Rent in ${this.marketName}.`
    },
    crossSellCopy() {
      return this.isRoomsOffering
        ? `Already have one or more roommates locked in? Consider these Entire Homes and Apartments for rent in ${this.marketName}.`
        : `Looking for roommates to share your new home with? Find a great room in Shared Houses or Shared Apartments in ${this.marketName}.`
    },
  },
}
</script>

<style lang="scss">
.listings-cross-sell {
  &__cta {
    position: absolute;
    right: 1.5rem;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 4.5rem;
    width: 4.5rem;
    border-radius: 100%;
    background: white;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    transition: all 0.25s ease;

    &.rooms {
      top: 10rem;
    }

    &.homes {
      top: 6.5rem;
    }

    img {
      height: 1.25rem;
      width: 1.25rem;
    }
  }

  &:hover {
    .listings-cross-sell__cta {
      color: white;
      background-color: $charcoal-60;
    }
  }

  &__cards {
    cursor: pointer;
    position: relative;

    // Opacity Overlay
    &::after {
      content: '';
      position: absolute;
      top: -6px;
      bottom: -6px;
      z-index: 1;
      width: 100% !important; // needed to override MLP layout
      transition: all 0.25s ease;
      background: rgb(255, 255, 255);
      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 20%,
        rgba(255, 255, 255, 0.5) 65%,
        rgba(255, 255, 255, 1) 100%
      );
    }
  }
}
</style>
